<template>
  <section class="s-breadcrumb">
    <div class="s-breadcrumb__col">
      <ul>
        <li v-for="(item, index) in links" :key="index">
          <a
            v-if="index !== links.length - 1"
            :href="item.href"
            :aria-label="ariaLabel(item)">
            <i v-if="index === 0" class="icon-home-fill"></i>
            <template v-else>
              {{ item.name }}
            </template>
          </a>

          <span v-if="index === links.length - 1">
            {{ item.name }}
          </span>
          <i v-if="index !== links.length - 1" class="icon-chevron-down"></i>
        </li>
      </ul>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    links: {
      default() {
        return []
      },
      type: Array,
    },
  },
  methods: {
    ariaLabel(item) {
      return `navigate to ${item.name}`
    },
  },
}
</script>
